import React from 'react';
import { getAllTemplates } from '../../../utils/smileTemplates';

const TemplatePanel = ({ selectedTemplateId, onApplyTemplate, referencePoints }) => {
  const templates = getAllTemplates();
  const hasEnoughPoints = referencePoints.midline && referencePoints.incisalEdge &&
    (referencePoints.leftCommissure || referencePoints.rightCommissure);

  return (
    <div>
      <h3 className="text-sm font-bold text-gray-800 mb-3">Smile Templates</h3>

      {!hasEnoughPoints && (
        <div className="mb-3 p-2.5 bg-amber-50 border border-amber-200 rounded-lg">
          <p className="text-[11px] text-amber-700">
            Place at least the <strong>midline</strong>, <strong>incisal edge</strong>, and one <strong>commissure</strong> point before applying a template.
          </p>
        </div>
      )}

      <p className="text-xs text-gray-500 mb-3">
        Select a template to auto-generate a tooth arch fitted to your reference points.
      </p>

      <div className="space-y-2">
        {templates.map(template => (
          <button
            key={template.id}
            onClick={() => onApplyTemplate(template)}
            disabled={!hasEnoughPoints}
            className={`w-full text-left p-3 rounded-lg border transition ${
              selectedTemplateId === template.id
                ? 'border-blue-400 bg-blue-50'
                : 'border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-40 disabled:hover:bg-white'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-gray-800">{template.name}</span>
              <span className="text-[10px] text-gray-400">{template.teethPerSide * 2} teeth</span>
            </div>
            <p className="text-[11px] text-gray-500 mt-0.5">{template.description}</p>

            {/* Mini preview bar showing relative tooth widths */}
            <div className="flex items-end justify-center gap-px mt-2 h-5">
              {[...template.teeth].reverse().map((t, i) => (
                <div
                  key={`l-${i}`}
                  className="bg-gray-300 rounded-t-sm"
                  style={{
                    width: `${t.relativeWidth * 14}px`,
                    height: `${t.relativeHeight * 20}px`,
                  }}
                />
              ))}
              {template.teeth.map((t, i) => (
                <div
                  key={`r-${i}`}
                  className="bg-gray-300 rounded-t-sm"
                  style={{
                    width: `${t.relativeWidth * 14}px`,
                    height: `${t.relativeHeight * 20}px`,
                  }}
                />
              ))}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TemplatePanel;
